var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"coupon-item-ctn"},[_c('div',{staticClass:"coupon-item"},[_c('div',{staticClass:"ui-nowrap coupon-name"},[_vm._v(_vm._s(_vm.name))])])])}
var staticRenderFns = []

export { render, staticRenderFns }